import React from 'react';
import { Select, Stack, Text, TextInput } from '@mantine/core';
import { UseFormReturnType } from '@mantine/form';
import { formatUserLabel, getSapOpsAreaOptions } from './helpers';
import {
    SapDivisionOption,
    VirtualDivisionFormValues,
    VirtualHierarchyUser,
    VirtualOpsAreaRow,
} from './types';

type Props = {
    form: UseFormReturnType<VirtualDivisionFormValues>;
    users: VirtualHierarchyUser[];
    sapDivisions: SapDivisionOption[];
    virtualOpsAreas: VirtualOpsAreaRow[];
};

const groupingOptions = [
    { value: 'sap', label: 'Leave in the SAP ops area' },
    { value: 'existing', label: 'Attach to an existing virtual ops area' },
    { value: 'new', label: 'Create a virtual ops area' },
];

export function VirtualHierarchyGroupingStep({
    form,
    users,
    sapDivisions,
    virtualOpsAreas,
}: Props) {
    const userOptions = users.map(user => ({
        value: user.id,
        label: formatUserLabel(user),
    }));
    const opsAreaOptions = virtualOpsAreas.map(opsArea => ({
        value: opsArea.id,
        label: opsArea.name,
    }));
    const sapOpsAreaOptions = getSapOpsAreaOptions(sapDivisions);

    return (
        <Stack gap="sm">
            <Text size="sm" c="dimmed">
                Leave this division in a SAP ops area, or group it under a
                virtual ops exec.
            </Text>
            <Select
                label="Grouping"
                data={groupingOptions}
                {...form.getInputProps('grouping')}
            />
            {form.values.grouping === 'sap' ? (
                <Select
                    label="SAP ops area"
                    placeholder="Select a SAP ops area"
                    searchable
                    data={sapOpsAreaOptions}
                    {...form.getInputProps('sapOpsAreaId')}
                />
            ) : null}
            {form.values.grouping === 'existing' ? (
                <Select
                    label="Virtual ops area"
                    placeholder="Select a virtual ops area"
                    searchable
                    data={opsAreaOptions}
                    {...form.getInputProps('virtualOpsAreaId')}
                />
            ) : null}
            {form.values.grouping === 'new' ? (
                <>
                    <TextInput
                        label="Virtual ops area name"
                        placeholder="Coastal"
                        {...form.getInputProps('newVirtualOpsAreaName')}
                    />
                    <Select
                        label="Virtual ops executive"
                        placeholder="Select a user"
                        searchable
                        data={userOptions}
                        {...form.getInputProps(
                            'newVirtualOpsAreaExecutiveUserId',
                        )}
                    />
                </>
            ) : null}
        </Stack>
    );
}
